<template>
  <section class="member-signup" v-if="subscriptionType !== 'student' && !askForInsurance">
    <div class="row">
      <div class="col-xs-12">
        <div class="field-wrapper full">
          <DropDownWithSearch id="dropdownEducationLevel" :label="d.educationLevelTitle + '*'"
            @change="ValidateDropDown($event, 'educationLevel')" :options="dictionaryEducationLevels" />

          <div class="input-errors" v-for="error of v$.values.educationLevel.$errors" :key="error.$uid">
            <div v-if="error.$validator == 'required' && !error.$response" class="error-msg">{{ d.errorhighesteducation
              }}</div>
          </div>
        </div>
      </div>
    </div>
  </section>

  <section class="member-signup" v-if="subscriptionType === 'student' || askForInsurance">
    <div class="row" v-if="!askForInsurance">
      <div class="col-xs-12">
        <div class="field-wrapper full">
          <label>{{ d.educationYourEducationTitle }}*</label>
          <div class="list-inline">
            <label class="radio">
              <input type="radio" name="yourEducation" required="true" v-model="values.educationType"
                value="videregaaendeuddannelse" @change="ResetValidation('education')" />
              <span class="checklabel">{{ d.educationradiohighereducation }}</span>
              <span class="checkmark"></span>
            </label>

            <label class="radio">
              <input type="radio" name="yourEducation" required="true" v-model="values.educationType"
                value="erhvervsuddannelse" @change="ResetValidation('trainee')" />
              <span class="checklabel">{{ d.educationradiovocationaleducation }}</span>
              <span class="checkmark"></span>
            </label>
          </div>
          <div class="input-errors" v-for="error of v$.values.educationType.$errors" :key="error.$uid">
            <div v-if="error.$validator == 'required' && !error.$response" class="error-msg">
              {{ d.erroreducation }}
            </div>
          </div>
        </div>
      </div>
    </div>

    <section v-if="isEducation || askForInsurance">
      <div class="row">
        <div class="col-xs-12">
          <div class="field-wrapper full">
            
            <DropDownWithSearch ref="educationInstitutionRef" id="educationInstitution"
              :label="d.educationInstitutionsTitle + '*'" @change="SetValue($event, 'educationInstitution')"
              :options="dictionaryEducationInstitutions" />
              
              <div v-html="validEducation(dictionaryEducationInstitutions, this.merges.personalDetails.educationInstitution)"></div>


            <div class="input-errors" v-for="error of v$.values.educationInstitution.$errors" :key="error.$uid">
              <div v-if="error.$validator == 'required' && !error.$response" class="error-msg">{{
                d.erroreducationinstitution }}</div>
            </div>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-xs-12">
          <div class="field-wrapper full">
            <DropDownWithSearch ref="educationCurrentRef" id="educationCurrent"
              :label="askForInsurance ? d.education + '*' : d.educationCurrentTitle + '*'"
              @change="SetValue($event, 'educationCurrent')" :options="dictionaryEducationCurrentFiltered" />

              <div v-html="validEducation(dictionaryEducationCurrentFiltered, this.merges.personalDetails.educationCurrent)"></div>


            <div class="input-errors" v-for="error of v$.values.educationCurrent.$errors" :key="error.$uid">
              <div v-if="error.$validator == 'required' && !error.$response" class="error-msg">{{
                d.erroreducationcurrent }}</div>
            </div>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-md-6 col-xs-12">
          <label for="educationStarted">{{ d.educationStarted }}*</label>
          <VueDatePicker @closed="SetDate('educationStarted')" :locale="GetCulture()" :format="dateFormat"
            :cancelText="d.cancel" :selectText="d.select" class="date-input-field" v-model="educationStarted"
            id="educationStarted" :placeholder="d.placeholderselectdate" :enable-time-picker="false" auto-apply
            month-name-format="long" @keydown="$event.code === 'Space' ? $event.preventDefault() : null">
            <template #input-icon><svg class="svg-calendar img-size">
                <use xlink:href="#svg-calendar"></use>
              </svg></template>
          </VueDatePicker>

          <div class="input-errors margin-fix" v-for="error of v$.values.educationStarted.$errors" :key="error.$uid">
            <div v-if="error.$validator == 'required' && !error.$response" class="error-msg">{{ d.errorSelectStartDate
              }}</div>
          </div>
        </div>

        <div class="col-md-6 col-xs-12">
          <label for="educationExpectedEnd">{{ askForInsurance ? d.ftfaEducationExpectedEnd : d.educationExpectedEnd
            }}*</label>
          <VueDatePicker @closed="SetDate('educationExpectedEnd')" :locale="GetCulture()" :format="dateFormat"
            :cancelText="d.cancel" :selectText="d.select" class="date-input-field" v-model="educationExpectedEnd"
            id="educationExpectedEnd" :placeholder="d.placeholderselectdate" :enable-time-picker="false" auto-apply
            month-name-format="long" @keydown="$event.code === 'Space' ? $event.preventDefault() : null">
            <template #input-icon><svg class="svg-calendar img-size">
                <use xlink:href="#svg-calendar"></use>
              </svg></template>
          </VueDatePicker>

          <div class="input-errors margin-fix" v-for="error of v$.values.educationExpectedEnd.$errors"
            :key="error.$uid">
            <div v-if="error.$validator == 'dateStartEndValidation' && !error.$response" class="error-msg">{{
              d.errorEndDateGreaterThanStartDate }}</div>
            <div v-if="error.$validator == 'dateValidation' && !error.$response" class="error-msg">{{
              d.errorSelectExpectedEndDate }}</div>
          </div>

          <HelperTip :rte="d.educationEndDate"></HelperTip>
        </div>
      </div>
    </section>

    <section v-if="isTrainee">
      <div class="row">
        <div class="col-xs-12">

          <div class="field-wrapper required">
            <DropDownWithSearchEndpoint ref="dropdownRef" id="traineeCompanyName"
              endpoint="/umbraco/api/signup/SearchCompanyList/?search=" execsearch="1" :noresults="d.searchNoResults"
              :label="d.placeholderTraineeCompanyName + '*'"
              @change="values.traineeCompanyName = $event.selectedValue?.name || $event">
            </DropDownWithSearchEndpoint>

           <div v-if="this.merges.personalDetails.traineeCompanyName" v-html="this.merges.personalDetails.traineeCompanyName"></div>


            <div class="input-errors no-margin" v-for="error of v$.values.traineeCompanyName.$errors" :key="error.$uid">
              <div v-if="error.$validator == 'required' && !error.$response" class="error-msg">{{ d.errorcompanyname }}
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-md-6 col-xs-12">
          <div class="field-wrapper half">
            <label for="trainee-company-address">{{ d.companyAddress }}</label>
            <input type="text" id="trainee-company-address" v-model="values.traineeCompanyAddress"
              :placeholder="d.placeholdertextbox" />
          </div>
        </div>

        <div class="col-md-6 col-xs-12">
          <div class="field-wrapper half">
            <label for="trainee-company-postal-code">{{ d.companyPostalCode }}</label>
            <input type="text" id="trainee-company-postal-code" v-model="values.traineeCompanyPostalCode"
              :placeholder="d.placeholdertextbox" />
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-md-6 col-xs-12">
          <div class="field-wrapper small">
            <DropDownWithSearch :ref="traineeWorkAreasRef" :id="traineeWorkAreas" :label="d.companyWorkArea + '*'"
              @change="handleAreaChange($event)" :options="dictionaryWorkAreas"></DropDownWithSearch>
            <div class="input-errors no-margin" v-for="error of v$.values.traineeWorkAreas.$errors" :key="error.$uid">
              <div v-if="error.$validator == 'required' && !error.$response" class="error-msg">{{ d.errorworkarea }}
              </div>
            </div>
          </div>
        </div>

        <div class="col-md-6 col-xs-12">
          <div class="field-wrapper small" v-show="values.traineeWorkAreas != null">
            <DropDownWithSearch :ref="`dropdownFunctionRef-${index}`" :id="traineeWorkFunctions"
              :label="d.companyWorkFunction + '*'" @change="handleFunctionChange($event, index)"
              :options="dictionaryWorkFunctions"></DropDownWithSearch>
            <div class="input-errors no-margin" v-for="error of v$.values.traineeWorkFunctions.$errors"
              :key="error.$uid">
              <div v-if="error.$validator == 'required' && !error.$response" class="error-msg">{{ d.errorworkfunction }}
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-md-6 col-xs-12">
          <label for="traineeStarted">{{ d.traineeStarted }}*</label>
          <VueDatePicker @closed="SetDate('traineeStarted')" :locale="GetCulture()" :cancelText="d.cancel"
            :selectText="d.select" class="date-input-field" v-model="traineeStarted" id="traineeStarted"
            :placeholder="d.placeholderselectdate" :format="dateFormat" :enable-time-picker="false" auto-apply
            month-name-format="long" @keydown="$event.code === 'Space' ? $event.preventDefault() : null">
            <template #input-icon><svg class="svg-calendar img-size">
                <use xlink:href="#svg-calendar"></use>
              </svg></template>
          </VueDatePicker>

          <div class="input-errors margin-fix" v-for="error of v$.values.traineeStarted.$errors" :key="error.$uid">
            <div v-if="error.$validator == 'required' && !error.$response" class="error-msg">{{ d.errorSelectStartDate
              }}
            </div>
          </div>
        </div>

        <div class="col-md-6 col-xs-12">
          <label for="traineeExpectedEnd">{{ d.traineeExpectedEnd }}*</label>
          <VueDatePicker @closed="SetDate('traineeExpectedEnd')" :locale="GetCulture()" :cancelText="d.cancel"
            :selectText="d.select" class="date-input-field" v-model="traineeExpectedEnd" id="traineeExpectedEnd"
            :placeholder="d.placeholderselectdate" :format="dateFormat" :enable-time-picker="false" auto-apply
            month-name-format="long" @keydown="$event.code === 'Space' ? $event.preventDefault() : null">
            <template #input-icon><svg class="svg-calendar img-size">
                <use xlink:href="#svg-calendar"></use>
              </svg></template>
          </VueDatePicker>

          <div class="input-errors margin-fix" v-for="error of v$.values.traineeExpectedEnd.$errors" :key="error.$uid">
            <div v-if="error.$validator == 'dateStartEndValidation' && !error.$response" class="error-msg">{{
              d.errorEndDateGreaterThanStartDate }}</div>
            <div v-if="error.$validator == 'required' && !error.$response" class="error-msg">{{
              d.errorSelectExpectedEndDate
            }}</div>
          </div>

          <HelperTip :rte="d.educationEndDate"></HelperTip>
        </div>
      </div>
    </section>
  </section>
</template>

<script>
import useVuelidate from "@vuelidate/core";
import axios from "axios";
//
// Datepicker documentation: https://vue3datepicker.com/
import VueDatePicker from "@vuepic/vue-datepicker";
import "@vuepic/vue-datepicker/dist/main.css";
import { cultureMixin } from "../../util/cultureMixin.js";
import DropDownWithSearch from "../FormComponents/DropDownWithSearch.vue";
import HelperTip from "../FormComponents/HelperTip.vue";
import DropDownWithSearchEndpoint from "../FormComponents/DropDownWithSearchEndpoint.vue";
import { h } from "vue";

export default {
  components: {
    DropDownWithSearchEndpoint,
    DropDownWithSearch,
    VueDatePicker,
    HelperTip,
  },
  props: {
    askForInsurance: Boolean,
  },
  mixins: [cultureMixin],
  setup() {
    // we use vuelidate for validation
    // https://vuelidate-next.netlify.app/
    return { v$: useVuelidate({ $lazy: true }) };
  },
  data: (instance) => {
    return {
      subscriptionType: instance.store.subscriptionType,
      values: instance.store[instance.store.currentCulture].values.personalDetails,
      d: instance.store[instance.store.currentCulture].dictionary,
      culture: instance.store.currentCulture,

      educationStarted: null,
      educationExpectedEnd: null,
      traineeStarted: null,
      traineeExpectedEnd: null,

      isEducation: false,
      isTrainee: false,

      dictionaryEducationLevels: [],
      dictionaryEducationIsLoading: false,
      dictionaryEducationError: null,

      dictionaryEducationInstitutions: [],
      dictionaryEducationInstitutionsIsLoading: false,
      dictionaryEducationInstitutionsError: null,

      dictionaryEducationCurrent: [],
      dictionaryEducationCurrentFiltered: [],
      dictionaryEducationCurrentLoading: false,
      dictionaryEducationCurrentError: null,

      dictionaryWorkAreas: [],
      dictionaryWorkAreasLoading: false,
      dictionaryWorkAreasError: null,

      dictionaryWorkFunctions: [],
      dictionaryWorkFunctionsLoading: false,
      dictionaryWorkFunctionsError: null,

      date: new Date(),
    };
  },
  computed: {},
  watch: {
    "values.educationType"(value) {
      this.SetVisuals(value);
    },
  },
  beforeUnmount() {
    this.emitter.off("culture-change", this.loadData);
  },
  methods: {
    loadData() {
      //
      // LOADS DATA
      this.GetEducationLevelData();
      this.GetEducationInstitutions();
      this.GetEducationCurrent();
      this.GetWorkAreas();
    },
    ResetValidation(field) {
      // RESET VALUES ON EDUCATION/TRAINEE CHANGE
      switch (field) {
        case "education":
          this.values.traineeCompanyName = null;
          this.values.traineeCompanyAddress = null;
          this.values.traineeCompanyPostalCode = null;
          this.values.traineeWorkAreas = null;
          this.values.traineeWorkFunctions = null;
          this.values.traineeStarted = null;
          this.values.traineeExpectedEnd = null;

          this.v$.values.educationType.$reset();
          break;

        case "trainee":
          this.values.educationInstitution = null;
          this.values.educationCurrent = null;
          this.values.educationStarted = null;
          this.values.educationExpectedEnd = null;

          this.v$.values.educationType.$reset();
          break;
      }
    },
    merge() {

      if (this.merges.personalDetails?.educationType == "Videregående uddannelse") {
        this.values.educationType = "videregaaendeuddannelse";
        this.isEducation = true;
        this.$nextTick(() => {
          if (this.$refs.educationCurrentRef && this.merges.personalDetails.educationCurrent) {
            this.$refs.educationCurrentRef.setValueByName(this.merges.personalDetails.educationCurrent);
          }
          if (this.$refs.educationInstitutionRef && this.merges.personalDetails.educationInstitution) {
            this.$refs.educationInstitutionRef.setValueByName(this.merges.personalDetails.educationInstitution);
          }
         
        });

        if (this.merges.personalDetails.educationStarted) {
          this.educationStarted = new Date(this.merges.personalDetails.educationStarted);
          this.values.educationStarted = new Date(this.merges.personalDetails.educationStarted);
        }
        if (this.merges.personalDetails.educationExpectedEnd) {
          this.educationExpectedEnd = new Date(this.merges.personalDetails.educationExpectedEnd);
          this.values.educationExpectedEnd = new Date(this.merges.personalDetails.educationExpectedEnd);
        }
      } else if (this.merges.personalDetails?.educationType == "Elev, erhvervsuddannelse") {
        this.values.educationType = "erhvervsuddannelse";
        this.isTrainee = true;
        this.$nextTick(() => {
          if (this.merges.personalDetails.traineeCompanyName) this.values.traineeCompanyName = this.merges.personalDetails.traineeCompanyName;
          if (this.merges.personalDetails.traineeCompanyAddress) this.values.traineeCompanyAddress = this.merges.personalDetails.traineeCompanyAddress;
          if (this.merges.personalDetails.traineeCompanyPostalCode) this.values.traineeCompanyPostalCode = this.merges.personalDetails.traineeCompanyPostalCode;
          if (this.merges.personalDetails.traineeStarted) {
            this.traineeStarted = new Date(this.merges.personalDetails.traineeStarted);
            this.values.traineeStarted = new Date(this.merges.personalDetails.traineeStarted);
          }
          if (this.merges.personalDetails.traineeExpectedEnd) {
            this.traineeExpectedEnd = new Date(this.merges.personalDetails.traineeExpectedEnd);
            this.values.traineeExpectedEnd = new Date(this.merges.personalDetails.traineeExpectedEnd);
          }
        });
      }
    },

    /* ----- */
    /* ADD WORK AREA AND FUNCTION */
    handleAreaChange(value, index) {
      const ref = this.$refs[`dropdownFunctionRef-${index}`];
      if (ref) ref.reset();

      // SET TRAINEE WORK FUNCTIONS
      this.dictionaryWorkFunctions = value.functions.map((x) => ({ id: x.subcategory, name: x.subcategoryText }));
      // SET TRAINEE WORK AREA - VALUE
      this.values.traineeWorkAreas = { id: value.id, name: value.name };

      // RESET FUNCTIONS
      // LOCAL
      this.traineeWorkFunctions = "";
      // STORE
      this.values.traineeWorkFunctions = "";
      // FORM VALUES
      this.v$.values.traineeWorkFunctions.$reset();
    },
    handleFunctionChange(value) {
      this.values.traineeWorkFunctions = value;
    },
    /* ADD WORK AREA AND FUNCTION */
    /* ----- */

    SetVisuals(value) {
      if (value && value != "videregaaendeuddannelse") {
        this.values.isEducation = false;
        this.values.isTrainee = true;
        this.values.educationInstitutionName = true;
        this.values.educationName = "";
        this.isEducation = false;
        this.isTrainee = true;

        // RESET Validations on change
        this.v$.values.traineeCompanyName.$reset();
        this.v$.values.traineeStarted.$reset();
        this.v$.values.traineeExpectedEnd.$reset();
        this.v$.values.traineeWorkAreas.$reset();
        this.v$.values.traineeWorkFunctions.$reset();
      } else {
        this.values.isEducation = true;
        this.values.isTrainee = false;
        this.isEducation = true;
        this.isTrainee = false;

        // RESET Validations on change
        this.v$.values.educationCurrent.$reset();
        this.v$.values.educationInstitution.$reset();
        this.v$.values.educationStarted.$reset();
        this.v$.values.educationExpectedEnd.$reset();
      }
    },
    ValidateDropDown(event, field) {
      this.values[field] = event;
      this.v$.values[field]?.$touch;
    },
    SetDate(field) {
      if (!field) return;

      switch (field) {
        case "educationStarted":
          var eduDateStart = new Date(this.educationStarted).toISOString();
          this.values.educationStarted = eduDateStart;
          break;

        case "educationExpectedEnd":
          var eduDateEnd = new Date(this.educationExpectedEnd).toISOString();
          this.values.educationExpectedEnd = eduDateEnd;
          break;

        case "traineeStarted":
          var traineeDateStart = new Date(this.traineeStarted).toISOString();
          this.values.traineeStarted = traineeDateStart;
          break;

        case "traineeExpectedEnd":
          var traineeDateEnd = new Date(this.traineeExpectedEnd).toISOString();
          this.values.traineeExpectedEnd = traineeDateEnd;
          break;
      }
    },
    SetValue(event, field) {
      if (!event) return;

      switch (field) {
        case "traineeCompanyName":
          this.values.traineeCompanyName = event.selectedValue.name;
          break;
        case "educationInstitution":
          this.values.educationInstitution = event.id;
          this.values.educationInstitutionName = event.name;
          this.FilterEducations(event.id);
          break;

        case "educationCurrent":
          this.values.educationCurrent = event.id;
          this.values.educationName = event.name;
          break;
      }
    },
    FilterEducations(guid) {
      this.$refs.educationCurrentRef.reset();
      const filter = this.dictionaryEducationCurrent.filter((f) => f.institutes.includes(guid));
      this.dictionaryEducationCurrentFiltered = filter;
    },
    async GetEducationLevelData() {
      this.dictionaryEducationIsLoading = true;
      this.dictionaryEducationError = null;

      try {
        const dataEducationLevels = await axios.get(`/umbraco/api/signup/GetEducationLevels?culture=${this.GetCulture()}`);
        this.dictionaryEducationLevels = dataEducationLevels.data;
      } catch (error) {
        this.dictionaryEducationError = "Der opstod en fejl under hentning af data:" + error.message;
        console.error(this.dictionaryEducationError);
      } finally {
        this.dictionaryEducationIsLoading = false;
      }
    },
    async GetEducationInstitutions() {
      this.dictionaryEducationInstitutionsIsLoading = true;
      this.dictionaryEducationInstitutionsError = null;

      try {
        const dataEducationInstitutions = await axios.get(`/umbraco/api/signup/GetEducationInstitutions?culture=${this.GetCulture()}`);
        this.dictionaryEducationInstitutions = dataEducationInstitutions.data;
      } catch (error) {
        this.dictionaryEducationInstitutionsError = "Der opstod en fejl under hentning af data:" + error.message;
        console.error(this.dictionaryEducationInstitutionsError);
      } finally {
        this.dictionaryEducationInstitutionsIsLoading = false;
      }
    },
    async GetEducationCurrent() {
      this.dictionaryEducationCurrentLoading = true;
      this.dictionaryEducationCurrentError = null;

      try {
        const dataEducationCurrent = await axios.get(`/umbraco/api/signup/GetEducations?culture=${this.GetCulture()}`);
        this.dictionaryEducationCurrent = dataEducationCurrent.data;
      } catch (error) {
        this.dictionaryEducationCurrentError = "Der opstod en fejl under hentning af data:" + error.message;
        console.error(this.dictionaryEducationCurrentError);
      } finally {
        this.dictionaryEducationCurrentLoading = false;
        this.dictionaryEducationCurrentFiltered = this.dictionaryEducationCurrent;
      }
    },
    async GetWorkAreas() {
      this.dictionaryWorkAreasLoading = true;
      this.dictionaryWorkAreasError = null;

      try {
        const dataWorkAreas = await axios.get(`/umbraco/api/signup/GetWorkAreas?culture=${this.GetCulture()}`);

        this.dictionaryWorkAreas = dataWorkAreas.data.map((x) => ({ id: x.category, name: x.categoryText, functions: x.subcategories }));
      } catch (error) {
        this.dictionaryWorkAreasError = "Der opstod en fejl under hentning af data:" + error.message;
        console.error(this.dictionaryWorkAreasError);
      } finally {
        this.dictionaryWorkAreasLoading = false;
      }
    },
    validEducation(collection, value) {
    
      if(value == null || value == undefined || value == "")
        return ""; // if value is null or undefined, return empty string
  

      let found = collection.some(item => 
         item.name.toLowerCase() == value.toLowerCase()
      );

     return !found ? `værdi fra crm : ${value}` :"";
      
    },
    dateFormat(date) {
      const day = date.getDate();
      const month = date.getMonth() + 1;
      const year = date.getFullYear();

      return `${day}-${month}-${year}`;
    },
  },
  mounted() {
    console.log("sadasd");
    this.loadData();

    this.emitter.on("culture-change", () => {
      this.values = this.store[this.store.currentCulture].values.personalDetails;
      this.d = this.store[this.store.currentCulture].dictionary;
      this.culture = this.store.currentCulture;

      // LOADS DATA ON LANGUAGE CHANGE
      this.loadData();

      this.v$.$reset();
    });

    if (this.merges) {
      this.merge();
    }
  },
  validations() {
    return this.validations.educationDetails;
  },
};
</script>

<style scoped lang="postcss">
.img-size {
  height: 29px;
  width: 25px;
  margin-left: 3px;
  color: var(--color-darkblue);
}

.input-errors {
  color: red;

  +.input-errors {
    margin-top: 0;
  }
}

input#traineeCompanyName {
  margin-bottom: 0;
}

.margin-fix {
  margin-top: -15px;
}

.no-margin {
  margin-top: 0;
}

.date-input-field>div>div>input {
  padding-left: 35px !import;
}
</style>
